var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Expand = function Expand(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 13 13' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'Combined Shape'
      ),
      React.createElement('path', { d: 'M6 6V.5a.5.5 0 1 1 1 0V6h5.5a.5.5 0 1 1 0 1H7v5.5a.5.5 0 1 1-1 0V7H.5a.5.5 0 1 1 0-1H6z', fill: 'currentColor', fillRule: 'nonzero'
      })
    )
  );
};
/*eslint-enable */

export default Expand;
//# sourceMappingURL=Expand.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Expand.js